/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid, Flex } from "frontend/src/components/Layout"
import { Icon } from "frontend/src/components/Icon"
import { CMSLink } from "frontend/src/components/CMSLink"
import Img from "gatsby-image"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"

function DynamicGrid(sections) {
  let grid
  switch (sections.length) {
    case 1:
      grid = "1fr"
      break
    case 2:
      grid = "1fr 1fr"
      break
    case 3:
      grid = "1fr 1fr 1fr"
      break
    default:
      grid = "1fr"
  }
  return grid
}

function CtaSection({ ctaArray }) {
  return (
    <SectionGrid>
      <SectionGrid.wide>
        <div
          sx={{
            display: "grid",
            gridTemplateColumns: ["1fr", "1fr", DynamicGrid(ctaArray)],
            justifyItems: "center",
            py: 5,
          }}
        >
          {ctaArray.map(
            ({
              headline,
              subLine,
              reasons,
              image,
              imageCaption,
              price,
              orgiginalPrice,
              ctaLink,
            }) => (
              <div
                sx={{
                  display: "grid",
                  py: 5,
                  gridTemplateColumns: "minmax(200px, 400px)",
                  justifyContent: "center",
                  boxShadow: "0px 4.50221px 20px rgba(0, 0, 0, 0.15)",
                }}
              >
                <h3 sx={{ variant: "text.h2", my: 2, textAlign: "center" }}>{headline}</h3>
                <h4 sx={{ variant: "text.h3", my: 2, textAlign: "center" }}>{subLine}</h4>
                <Img
                  sx={{
                    height: "400px",
                    mx: 5,
                  }}
                  fluid={getFluidFromAsset(image, 400)}
                  imgStyle={{ objectFit: "contain", objectPosition: "center center" }}
                />
                <p sx={{ variant: "text.body1", my: 2, textAlign: "center" }}>{imageCaption}</p>
                <p
                  sx={{
                    variant: "text.subtitle1",
                    my: 2,
                    pb: 3,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {price} statt{" "}
                  <span sx={{ textDecoration: "line-through", color: "#911616" }}>
                    {orgiginalPrice}
                  </span>
                </p>
                <CMSLink
                  sx={{
                    py: 5,
                    width: "90%",
                    textAlign: "center",
                    bg: "almostBlack",
                    color: "white",
                    textTransform: "uppercase",
                    justifySelf: "center",
                  }}
                  link={{
                    event: "anchorClick",
                    destination: "offerSection",
                    pageType: "LandingPage",
                    ...ctaLink,
                  }}
                />
                <div sx={{ maxWidth: "90%", ml: "5%", py: 3 }}>
                  {reasons.map(({ title, icon }) => (
                    <Flex.row align="center" sx={{ my: 4 }}>
                      <Icon name={icon} size={22} color="black" />
                      <div sx={{ ml: 3 }}>{title}</div>
                    </Flex.row>
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      </SectionGrid.wide>
    </SectionGrid>
  )
}

export { CtaSection }
